import { render, staticRenderFns } from "./bounty-tab-header.vue?vue&type=template&id=78fc74f8&scoped=true&lang=pug&"
import script from "./bounty-tab-header.vue?vue&type=script&lang=js&"
export * from "./bounty-tab-header.vue?vue&type=script&lang=js&"
import style0 from "./bounty-tab-header.vue?vue&type=style&index=0&id=78fc74f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc74f8",
  null
  
)

export default component.exports